import { localProductVariants } from '../data';

export const findProductVariantDataByHandle = (
  handle: string
):
  | {
      id: number;
      handle: string;
      power?: string | undefined;
      productId: number;
    }
  | undefined => {
  return localProductVariants.find(
    (variantData) => variantData.handle === handle
  );
};
